(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageDialogController', DocumentVersionPageDialogController);

    DocumentVersionPageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'DocumentVersionPage', 'DocumentVersion'];

    function DocumentVersionPageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, DocumentVersionPage, DocumentVersion) {
        var vm = this;

        vm.documentVersionPage = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.documentversions = DocumentVersion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentVersionPage.id !== null) {
                DocumentVersionPage.update(vm.documentVersionPage, onSaveSuccess, onSaveError);
            } else {
                DocumentVersionPage.save(vm.documentVersionPage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:documentVersionPageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, documentVersionPage) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documentVersionPage.data = base64Data;
                        documentVersionPage.dataContentType = $file.type;
                    });
                });
            }
        };

    }
})();
